import React, { useCallback, useEffect } from 'react';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import { withTransition } from '~/ui/transition/Transition';
import { Overlay } from '~/ui/overlay/Overlay';
import { ConfidentialHotline } from './comments/ConfidentialHotline';
import { Faq } from './faq/Faq';
import { OpenHelpMenuButton } from './OpenHelpMenuButton';
import { ReportIssue } from './comments/ReportIssue';
import { Root } from './Root';
import { HelpPages, useHelpStore } from './Store';
import { useOpenCloseAudioEffect } from '~/ui/audio-effect/useOpenCloseAudioEffect';

const SettingsUI = () => {
  const { open, toggle, page } = useHelpStore();
  const OverlayWithTransition = withTransition(Overlay);
  useOpenCloseAudioEffect(open);

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      toggle(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction);

    return () => {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  const rootEl = document.getElementById('root');

  useEffect(() => {
    if (rootEl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rootEl.inert! = open;
    }
  }, [open]);

  useEffect(() => {
    if (rootEl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rootEl.inert! = false;
    }
  }, []);

  return (
    <>
      <OpenHelpMenuButton />
      <OverlayWithTransition
        show={open}
        open={open}
        onClick={() => toggle(false)}
      >
        {page !== HelpPages.FAQ ? (
          <LlamaModal
            horizontal="right"
            vertical="top"
            close={() => toggle(false)}
          >
            <Root />
            <ReportIssue />
            <ConfidentialHotline />
          </LlamaModal>
        ) : (
          <Faq />
        )}
      </OverlayWithTransition>
    </>
  );
};

export const Help = () => (
  <>
    <SettingsUI />
  </>
);
